import { render, staticRenderFns } from "./XRLibrary.vue?vue&type=template&id=b1345fb8"
import script from "./XRLibrary.vue?vue&type=script&lang=js"
export * from "./XRLibrary.vue?vue&type=script&lang=js"
import style0 from "./XRLibrary.vue?vue&type=style&index=0&id=b1345fb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports